import React, { useMemo } from 'react'

import { getTypeformUrl, KEY_INTEGRATIONS } from '@/core/api/data/typeforms'
import { useAuth } from '@/core/hooks/useAuth'
import { useTranslation } from '@/core/i18n/useTranslation'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/shared/components/molecules/Dialog/dialog'

interface TypeformModalProps {
	isOpen: boolean
	onClose: () => void
}

const TypeformModal: React.FC<TypeformModalProps> = ({ isOpen, onClose }) => {
	const { t, i18n } = useTranslation('common')
	const { user } = useAuth()

	const typeformUrl = useMemo(() => {
		return getTypeformUrl(KEY_INTEGRATIONS, i18n.language, 'brandtrack')
	}, [i18n.language, user])

	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent className="max-w-4xl w-full h-[90vh] p-0">
				<DialogHeader className="p-6 pb-0">
					<DialogTitle>{t('integrations.request_custom')}</DialogTitle>
				</DialogHeader>
				<div className="flex-1 min-h-[80vh] p-6 pt-0">
					<iframe
						src={typeformUrl || 'fXiH1ulj'}
						width="100%"
						height="100%"
						className="border-0 rounded-lg"
						title="Integration Setup Form"
					/>
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default TypeformModal
